
(function(){
  function init(root){
    if(!root || root.dataset.mlInit === 'true') return;
    root.dataset.mlInit='true';

    const links=[...root.querySelectorAll('.ml-side-nav a')];
    const sections=[...root.querySelectorAll('.ml-policy')];

    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            links.forEach(a=>a.classList.toggle('is-active',a.getAttribute('href')==='#'+entry.target.id));
          }
        });
      },{rootMargin:'-32% 0px -58% 0px'});
      sections.forEach(section=>io.observe(section));
    }

    root.querySelectorAll('a[href^="#"]').forEach(link=>{
      link.addEventListener('click',function(e){
        const id=this.getAttribute('href');
        if(!id || id==='#') return;
        const target=root.querySelector(id);
        if(!target) return;
        e.preventDefault();
        target.scrollIntoView({behavior:'smooth',block:'start'});
        history.replaceState(null,'',id);
      });
    });
  }

  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('.mialica-legal-hub').forEach(init));
  document.addEventListener('shopify:section:load',e=>{
    const root=e.target.querySelector('.mialica-legal-hub') || (e.target.matches?.('.mialica-legal-hub') ? e.target : null);
    if(root) init(root);
  });
})();
